import { callCloudFunc } from "./utils";
import { NewPlan } from "@pslifestyle/common/src/schemas/api-payload";
import { InitializeUserResponseData } from "@pslifestyle/common/src/types/api/responseTypes";
import { NewAnswerSet } from "@pslifestyle/common/src/types/questionnaireTypes";
import { HttpsCallableResult } from "firebase/functions";

export const requestMagicLinkEmail = (
  email: string,
  anonId: string,
  languageCode: string,
  countryCode: string,
): Promise<HttpsCallableResult<InitializeUserResponseData>> =>
  callCloudFunc("requestLink", {
    email,
    anonId,
    languageCode,
    countryCode,
    version: 1,
  });

export const requestMagicLinkEmailAndAscendUser = (
  email: string,
  anonId: string,
  languageCode: string,
  countryCode: string,
  answerSet: NewAnswerSet,
  plan: NewPlan,
): Promise<HttpsCallableResult<InitializeUserResponseData>> =>
  callCloudFunc("requestLink", {
    email,
    anonId,
    languageCode,
    countryCode,
    ascend: {
      answerSet,
      plan,
    },
    version: 1,
  });
